import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Column, Tag, Text } from '@dossierhq/design';
export function ValuesEditor({ readOnly, value, onChange }) {
    if (readOnly) {
        if (value.length === 0) {
            return (_jsx(Text, { style: { marginTop: '0.35em' }, textStyle: "body1", children: "Not set" }));
        }
        return (_jsx(Tag.Group, { children: value.map((it, index) => (_jsx(Tag, { children: it.value }, index))) }));
    }
    const handleAddValue = () => {
        const item = window.prompt('Enter a value');
        if (item) {
            onChange([...value, { value: item }]);
        }
    };
    const handleRemoveIndex = (index) => {
        const newValue = [...value];
        newValue.splice(index, 1);
        onChange(newValue);
    };
    return (_jsxs(Column, { style: value.length > 0 ? { marginTop: '0.35em' } : undefined, children: [_jsx(Tag.Group, { children: value.map((it, index) => (_jsxs(Tag, { transform: "", children: [it.value, _jsx(Tag.Remove, { onClick: () => handleRemoveIndex(index) })] }, index))) }), _jsx(Button, { onClick: handleAddValue, children: "Add" })] }));
}
//# sourceMappingURL=ValuesEditor.js.map